import { render, staticRenderFns } from "./blogCommentList.vue?vue&type=template&id=18b7b165&scoped=true&"
import script from "./blogCommentList.vue?vue&type=script&lang=js&"
export * from "./blogCommentList.vue?vue&type=script&lang=js&"
import style0 from "./blogCommentList.vue?vue&type=style&index=0&id=18b7b165&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7b165",
  null
  
)

export default component.exports